"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCreateGiftModule = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _reactRedux = require("react-redux");

var _ramda = require("ramda");

var _useGift2 = require("./hooks/useGift");

var _gift = require("./store/gift/gift.selector");

var _campaigns = require("./store/campaigns/campaigns.selector");

var _recipient = require("./store/recipient/recipient.actions");

var _gift2 = require("./store/gift/gift.actions");

/**
 * Create gift module hook.
 *
 * @namespace
 * @param {Object} props
 * @prop {number} [props.recipientId=null] - Contact id, to whom a gift will be sent.
 *                                           You cannot create gift while recipient id not set.
 * @prop {string} [props.sfLeadId=null]    - Salesforce gift lead id
 * @prop {string} [props.sfContactId=null]    - Salesforce gift contact id
 * @prop {number} [props.campaignId=null]  - Campaign id that will be assigned to the gift.
 *                                           You cannot create gift when is not set.
 *                                           You cannot fetch marketplace and product details when is not set.
 * @prop {number} [props.productId=null]   - Product id that will be assigned to the gift.
 *                                           You cannot fetch product details when is not set.
 * @returns {Object} - Hook control interface.
 */
var useCreateGiftModule = function useCreateGiftModule() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$recipientId = _ref.recipientId,
      recipientId = _ref$recipientId === void 0 ? null : _ref$recipientId,
      _ref$sfLeadId = _ref.sfLeadId,
      sfLeadId = _ref$sfLeadId === void 0 ? null : _ref$sfLeadId,
      _ref$sfContactId = _ref.sfContactId,
      sfContactId = _ref$sfContactId === void 0 ? null : _ref$sfContactId,
      _ref$campaignId = _ref.campaignId,
      initialCampaignId = _ref$campaignId === void 0 ? null : _ref$campaignId;

  var dispatch = (0, _reactRedux.useDispatch)();

  var _useState = (0, _react.useState)(initialCampaignId || null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      campaignId = _useState2[0],
      setCampaignId = _useState2[1];

  var campaign = (0, _reactRedux.useSelector)((0, _react.useMemo)(function () {
    return (0, _campaigns.makeGetCampaignById)(Number(campaignId));
  }, [campaignId]));
  var teamSettings = (0, _ramda.pathOr)({}, ['team', 'settings'], campaign);
  var errors = (0, _reactRedux.useSelector)(_gift.getGiftErrors);
  var isLoading = (0, _reactRedux.useSelector)(_gift.getGiftIsLoading);

  var _useGift = (0, _useGift2.useGift)(),
      id = _useGift.id,
      createGift = _useGift.create;

  (0, _react.useEffect)(function () {
    if (errors && errors.campaign_id) {
      dispatch((0, _gift2.giftClearError)(['campaign_id']));
      setCampaignId(campaignId);
    }
  }, [errors, campaignId, dispatch]);
  return {
    /**
     * State Props
     */
    campaignId,

    /**
     * App State Props
     */
    campaign,
    isLoading,
    teamSettings,

    /**
     * Setters
     */
    setCampaignId: (0, _react.useCallback)(function (cid) {
      return setCampaignId(cid);
    }, []),

    /**
     * Methods
     */

    /**
     * Create gift without product.
     * It will be pushed to full research or ai research is instant gift feature enabled.
     */
    createGift: (0, _react.useCallback)(function () {
      createGift({
        sfContactId,
        sfLeadId,
        campaignId,
        recipientId
      });
      setCampaignId(null);
    }, [campaignId, createGift, recipientId, sfLeadId, sfContactId]),

    /**
     * Hook that watch on gift id creation
     *
     * @param {function(giftId: number)} cb - Callback that will be called when gift has been created,
     */
    useOnCreate: function useOnCreate(cb) {
      (0, _react.useEffect)(function () {
        if (id) {
          cb(id);
        }

        return function () {
          return dispatch((0, _recipient.giftCreateRecipientReset)());
        };
      }, // eslint-disable-next-line react-hooks/exhaustive-deps
      [cb, id]);
    }
  };
};

exports.useCreateGiftModule = useCreateGiftModule;